import React from 'react';
import classnames from 'classnames';
import { Activity, SearchEntity } from 'v2/models';
import styles from './searchActivityItem.module.scss';
import { formatDate } from 'v2/utils/dateUtils';
import { Button, ButtonVariant } from 'v2/common/Button';
import { ActivityTitleComponent, ActivityBodyComponent } from './components';

interface SearchActivityItemProps {
  activity: Activity;
  search: SearchEntity;
  isFirstItem?: boolean;
  onRemove?: () => void;
}

export const SearchActivityItem = ({
  activity,
  isFirstItem = false,
  search,
  onRemove,
}: SearchActivityItemProps) => {
  return (
    <div
      className={classnames(styles.itemContainer, {
        [styles.firstItemContainer]: isFirstItem,
      })}
    >
      <div className={classnames(styles.itemHeader)}>
        <p className={classnames(styles.activityDate)}>
          {formatDate(activity.timestamp, true)}
        </p>

        {onRemove && (
          <Button variant={ButtonVariant.link} onClick={onRemove}>
            Remove
          </Button>
        )}
      </div>

      <ActivityTitleComponent activity={activity} search={search} />

      <div className={styles.activityBody}>
        <ActivityBodyComponent activity={activity} />
      </div>
    </div>
  );
};
